<aside id="sidebar-menu" [ngClass]="{
    'translate-x-0': isLgUp() || mobileOpen,
    '-translate-x-full': !isLgUp() && !mobileOpen,
    'lg:w-[90px]': isLgUp() && isCollapsed,
    'w-[272px]': true,
    'xl:static': true,
    'xl:translate-x-0': true,
    'pt-14': showGraceBannerOffset()
  }"
  class="sidebar fixed left-0 top-0 z-[9999] flex h-screen flex-col overflow-hidden border-r border-gray-200 bg-white px-4 transition-all duration-300 dark:border-gray-800 dark:bg-black"
  [attr.aria-hidden]="isLgUp() ? null : !mobileOpen" role="navigation" aria-label="Menú principal de navegación">
  <div [ngClass]="isCollapsed ? 'justify-center' : 'justify-between'"
    class="sidebar-header flex items-center gap-2 pt-6 pb-4">
    <a routerLink="/dashboard">
      <span class="logo" [ngClass]="isCollapsed ? 'hidden' : ''">
        <img class="dark:hidden" src="./assets/images/logo/new-logo.svg" alt="Logo CitaLink Pro">
        <img class="hidden dark:block" src="./assets/images/logo/new-logo-dark.svg" alt="Logo CitaLink Pro">
      </span>

      <img class="logo-icon" [ngClass]="isCollapsed ? 'lg:block' : 'hidden'"
        src="./assets/images/logo/new-icon-logo.svg" alt="Logo CitaLink Pro" />
    </a>
    <!-- Mobile close button -->
    <button *ngIf="!isLgUp() && !isCollapsed" (click)="closeMobileSidebar()"
      class="lg:hidden flex h-8 w-8 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800"
      aria-label="Cerrar menú">
      <svg class="fill-current" width="20" height="20" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M6.21967 7.28131C5.92678 6.98841 5.92678 6.51354 6.21967 6.22065C6.51256 5.92775 6.98744 5.92775 7.28033 6.22065L11.999 10.9393L16.7176 6.22078C17.0105 5.92789 17.4854 5.92788 17.7782 6.22078C18.0711 6.51367 18.0711 6.98855 17.7782 7.28144L13.0597 12L17.7782 16.7186C18.0711 17.0115 18.0711 17.4863 17.7782 17.7792C17.4854 18.0721 17.0105 18.0721 16.7176 17.7792L11.999 13.0607L7.28033 17.7794C6.98744 18.0722 6.51256 18.0722 6.21967 17.7794C5.92678 17.4865 5.92678 17.0116 6.21967 16.7187L10.9384 12L6.21967 7.28131Z"
          fill="" />
      </svg>
    </button>
  </div>

  @let collapsed = isCollapsed && isLgUp();

  <!-- One menu link: shared by the sections and the pinned footer -->
  <ng-template #menuLink let-item>
    <div class="flex items-center gap-1">
      <a [routerLink]="isExpired() && item.route !== '/settings/billing' ? null : item.route"
        routerLinkActive="sb-item--active" #rla="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: item.route !== '/settings' }"
        class="sb-item" [class.sb-item--collapsed]="collapsed"
        [class.pointer-events-none]="isExpired() && item.route !== '/settings/billing'"
        [attr.title]="collapsed ? item.label : null"
        [attr.aria-label]="collapsed ? item.label : null"
        (click)="onSelect(item.label, $event, item.route)" [attr.aria-current]="rla.isActive ? 'page' : null">
        <span class="sb-item__icon" aria-hidden="true">
          @switch (item.iconKey) {
            @case ('dashboard') { <app-dashboard-icon /> }
            @case ('agendas') { <app-calendar-icon /> }
            @case ('customers') { <app-users-icon /> }
            @case ('staff') { <app-users-staff /> }
            @case ('schedules') { <app-agenda-icon /> }
            @case ('schedule-pending') { <app-schedule-pending-icon /> }
            @case ('walk-ins') { <app-walk-ins-icon /> }
            @case ('finance') { <app-finance-icon /> }
            @case ('services') { <app-service-icon [businessTypeName]="currentBusinessTypeName()" /> }
            @case ('reminders') { <app-reminder-icon /> }
            @case ('reports') { <app-reports-icon /> }
            @case ('inventory') { <app-inventory-icon /> }
            @case ('promos') { <app-promotion-icon /> }
            @case ('bundles') { <app-plans-icon /> }
            @case ('settings') { <app-setting-icon /> }
          }
        </span>
        @if (!collapsed) {
        <span class="sb-item__text">{{ item.label }}</span>
        }
      </a>

      <!-- Contextual quick action: calendar toggle on /agendas route -->
      @if (isAgendasRoute() && item.route === '/agendas' && !collapsed) {
      <button type="button" (click)="onAgendaQuickAction($event)" class="sb-toggle"
        [class.sb-toggle--on]="showAgendaPanel()"
        [attr.aria-label]="showAgendaPanel() ? 'Ocultar panel de calendario' : 'Mostrar panel de calendario'"
        [attr.aria-expanded]="showAgendaPanel()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          @if (showAgendaPanel()) {
            <path d="m18 15-6-6-6 6"/>
          } @else {
            <path d="m6 9 6 6 6-6"/>
          }
        </svg>
      </button>
      }
    </div>
  </ng-template>

  <div class="sb-scroll no-scrollbar">
    <nav aria-label="Secciones">
      @for (section of menuSections(); track section.key) {
      <div class="sb-section" [attr.role]="section.title ? 'group' : null"
        [attr.aria-label]="section.title">
        @if (section.title) {
          @if (collapsed) {
          <hr class="sb-divider" />
          } @else {
          <p class="sb-section__title" aria-hidden="true">{{ section.title }}</p>
          }
        }
        <ul class="sb-list">
          @for (item of section.items; track item.route) {
          <li *appHasAny="item.anyOf">
            <ng-container *ngTemplateOutlet="menuLink; context: { $implicit: item }"></ng-container>
          </li>
          }
        </ul>

        <!-- Contextual agenda panel: calendar + professionals, right under the Agenda section -->
        @if (section.key === 'agenda' && isAgendasRoute() && showAgendaPanel() && !collapsed) {
        <div class="sb-agenda-panel">
          <app-appointment-calendar (dateSelected)="onDayClick($event)"></app-appointment-calendar>
          @if (!isExpired()) {
          <app-professional-list [isCollapsed]="false" [isLgUp]="isLgUp()" />
          }
        </div>
        }
      </div>
      }
    </nav>
  </div>

  <div class="sb-footer">
    <!-- Trial/expired notice (only outside agendas, where the calendar panel needs the room) -->
    @if (!isAgendasRoute() && !collapsed && ((membershipStatus()?.status === 'trial' && !isExpired()) || isExpired())) {
    <div class="sb-trial" [attr.data-tone]="trialTone()">
      @if (isExpired()) {
      <p class="sb-trial__title">Tu membresía expiró</p>
      <p class="sb-trial__text">Elige un plan para volver a usar tu agenda.</p>
      } @else {
      <p class="sb-trial__title">
        @if (trialDaysRemaining() !== null && trialDaysRemaining()! > 0) {
        {{ trialDaysRemaining() === 1 ? 'Queda 1 día' : 'Quedan ' + trialDaysRemaining() + ' días' }} de prueba
        } @else {
        Tu prueba termina hoy
        }
      </p>
      <p class="sb-trial__text">Elige un plan para seguir sin interrupciones.</p>
      }
      <a [routerLink]="['/settings/billing']" [queryParams]="{ view: 'plans' }" rel="nofollow" class="sb-trial__cta">
        {{ isExpired() ? 'Pagar ahora' : 'Elegir un plan' }}
      </a>
    </div>
    }

    @if (footerMenu().length) {
    <ul class="sb-list">
      @for (item of footerMenu(); track item.route) {
      <li *appHasAny="item.anyOf">
        <ng-container *ngTemplateOutlet="menuLink; context: { $implicit: item }"></ng-container>
      </li>
      }
    </ul>
    }
  </div>
</aside>

<app-modal [open]="openForm" [title]="'Realizar atención'" [size]="'md-1'" [bodyComponent]="EventAddForm"
  (confirm)="onModalConfirm($event)" [closeOnBackdrop]="false" [bodyInputs]="modalBodyInputs" (close)="openForm = false"
  confirmButtonText="Agendar" [isSaving]="savingEvent()">
</app-modal>
